import Vue from 'vue'
import Vuex from 'vuex'
import common from './modules/common'
import transData from './modules/transData'

Vue.use(Vuex)
const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    common,
    transData
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js